export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20minimalist%20fashion%20editorial%20scene%20featuring%20a%20carefully%20curated%20arrangement%20of%20contemporary%20sneakers%20hoodies%20and%20accessories%20on%20a%20pristine%20light%20sand%20colored%20surface%2C%20warm%20golden%20hour%20sunlight%20casting%20long%20gentle%20shadows%2C%20magazine%20editorial%20quality%20with%20clean%20negative%20space%2C%20sophisticated%20commercial%20photography%20style%20with%20organic%20textiles%20draped%20naturally&width=1600&height=900&seq=hero-v2-a1b2c3&orientation=landscape"
          alt="Curated fashion spreadsheet collection - pandabuy.living"
          title="PandabuySpreadsheet fashion collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-8">
          <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
          <span className="text-background-50 text-xs md:text-sm font-medium tracking-wide">Updated Daily · 1000+ Verified Items</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-6 text-balance">
          The Most Trusted <span className="italic text-primary-300">PandabuySpreadsheet</span> Collection for 2026
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover curated pandabuyspreadsheet lists with the best fashion, shoes, and accessories &mdash; updated daily for quality, price, and reliability.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#categories"
            className="w-full sm:w-auto px-8 py-4 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore Spreadsheet Database
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-4 rounded-full border-2 border-background-50/80 text-background-50 text-sm md:text-base font-semibold hover:bg-background-50 hover:text-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          <div className="flex items-center gap-2 text-background-50/70 text-xs md:text-sm">
            <i className="ri-check-line text-accent-400"></i>
            <span>Updated Daily</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/70 text-xs md:text-sm">
            <i className="ri-check-line text-accent-400"></i>
            <span>1000+ Verified Items</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/70 text-xs md:text-sm">
            <i className="ri-check-line text-accent-400"></i>
            <span>Beginner Friendly</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#what-is" className="flex flex-col items-center gap-2 text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">
          <span className="text-xs tracking-widest uppercase">Scroll</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}